export default __webpack_public_path__ + "assets/media/Bottom_Banner_TABLET.c17afecc.webp";